module.exports = __webpack_public_path__ + "static/media/doninger.a51baed5.jpg";